import { createGlobalStyle } from "styled-components"

const GlobalStyles = createGlobalStyle`
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
	}

  html, body, #root {
    display: flex;
    width: 100%;
    height: 100%;
    font-family: "Lato", sans-serif;
  }

  body{
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    background: #FFF;
  }
`

export default GlobalStyles
